import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Observable, SubscriptionLike } from 'rxjs';
import {
  getPlacedSkuDetail,
  getPlanogramImageUrl,
  noWhitespaceValidator,
} from 'src/helper/app-utils';
import {
  PlanogramBaseDetailModal,
  SKUModal,
  PlanogramBaseDetailInfo,
  PlanogramSegmentEntityModal,
  ScreenDataModal,
  coolerDataInterface,
  PlanogramNPDDetailInfo,
} from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { ConfirmDialogModalComponent } from '../confirm-dialog-modal/confirm-dialog-modal.component';
import { CONFIG } from 'src/helper/app-config';
import { AzureBlobStorageService } from 'src/services/azure-blob-storage.service';
import { MatSelectChange } from '@angular/material/select';
import { environment } from 'src/environments/environment';
import { AdminGuidelinesInputComponent } from '../admin-guidelines-input/admin-guidelines-input.component';

@Component({
  selector: 'app-admin-setup-component',
  templateUrl: './admin-setup-component.component.html',
  styleUrl: './admin-setup-component.component.css',
})
export class AdminSetupComponentComponent {
  stepper_index: number = 0;
  isReset = false;
  temp_stepper_index: number = 0;
  is_show_loader: Observable<boolean> = this.planogramState.loader;
  payload: any = {};
  planogram_id;
  npds_data_valid=false;
  @ViewChild(AdminGuidelinesInputComponent)
  adminGuidelinesInputComponent!: AdminGuidelinesInputComponent;
  constructor(
    private planogramState: PlanogramStateService,
    private router: Router
  ) {
    const router_state = this.router.getCurrentNavigation()?.extras.state;
    console.log('router_state', router_state);
    this.payload = router_state?.['payload'] || {};
    this.planogram_id = router_state?.['planogram_id'];
    let from = router_state?.['from'];
    if (this.payload.channel) {
      localStorage.setItem('admin_channel', this.payload.channel);
      localStorage.setItem('admin_cooler', this.payload.cooler_type);
      localStorage.setItem('admin_version', this.payload.version);
      localStorage.setItem('admin_unit', this.payload.unit);
      localStorage.setItem(
        'guideline_version_name',
        router_state?.['guideline_version_name']
      );
    }
    if (
      localStorage.getItem('stepper_index') &&
      from !== 'admin-updates-guidelines'
    ) {
      this.stepper_index = Number(localStorage.getItem('stepper_index'));
      console.log('this.stepper_index', this.stepper_index);
    } else if (router_state) {
      this.stepper_index = router_state['screen_index']
        ? router_state['screen_index']
        : this.stepper_index;
    }
    localStorage.setItem('stepper_index', String(this.stepper_index));
  }


  setStepperIndex = (event: any) => {
    this.updateStepperIndex(event.selectedIndex);
  };

  updateStepperIndex = (index: number) => {
    this.stepper_index = index;
    if (this.stepper_index == 0) {
      this.moveBackToLibrary();
    }
    localStorage.setItem('stepper_index', String(this.stepper_index));
  };

  moveBackToLibrary() {
    this.router.navigateByUrl(CONFIG.PATH.ADMIN_UPDATE_GUIDELINES);
    this.updateStepperIndex(1);
  }

  resetPlanogram(event: any) {
    this.isReset = event.reset;
  }

  createGuidelinesVersion() {
    this.adminGuidelinesInputComponent.createPlanogramVersion();
    setTimeout(() => {
      this.stepper_index = 2;
    }, 1000);
  }

  publishPlanogram() {
    let info = {
      screen_index: this.stepper_index,
      id: this.planogram_id,
    };

    this.planogramState.savePlanogramSkuPlacement(
      info,
      true,
      // name,
      localStorage.getItem('cooler') || '',
      this.planogram_id,
      undefined,
      "admin"
    );
  }

  checkNpdsValidationInGuidelines(event: any) {
    this.npds_data_valid = event.valid;
    console.log('this.npds_data_valid=========>', this.npds_data_valid);
  }

}
